import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css"; // Ensure this path is correct
import "../css/index.css";  // Ensure this path is correct
import { Link } from "react-router-dom";


const Hero = () => {
  return (
    <div className="main clearfix position-relative">
      <div className="main_1 clearfix">
        <section id="center" className="center_home">
          <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
              <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="0" className="active" aria-label="Slide 1"></button>
              <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="1" aria-label="Slide 2"></button>
              <button type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to="2" aria-label="Slide 3"></button>
            </div>

            <div className="carousel-inner">
              <div className="carousel-item active">
                <img src="img/White and Green Simple  Professional Business Project Presentation-1.png" className="d-block w-100" alt="Slide 1" />
                <div className="carousel-caption d-md-block">
                  <h6>Best Price</h6>
                  <h2 className="col_yell mt-3"></h2>
                  <h1 className="mt-3">The Most Complete Electrical Shop</h1>
                  <p className="mt-3">Irfan Electricals provides quality electrical products and reliable services.</p>
                  <ul className="mt-3 mb-0">
                    <li className="d-inline-block text-uppercase me-2">
                      <Link className="button" to="/shop">Shop Now</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="carousel-item">
                <img src="img/White and Green Simple  Professional Business Project Presentation-1.png" className="d-block w-100" alt="Slide 2" />
                <div className="carousel-caption d-md-block">
                  <h6>Best Price</h6>
                  <h2 className="col_yell mt-3"></h2>
                  <h1 className="mt-3">The Most Complete Electrical Shop</h1>
                  <p className="mt-3">Irfan Electricals provides quality electrical products and reliable services.</p>
                  <ul className="mt-3 mb-0">
                    <li className="d-inline-block text-uppercase me-2">
                      <a className="button" href="/shop">Shop Now</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="carousel-item">
                <img src="img/White and Green Simple  Professional Business Project Presentation-1.png" className="d-block w-100" alt="Slide 3" />
                <div className="carousel-caption d-md-block">
                  <h6>Best Price</h6>
                  <h2 className="col_yell mt-3"></h2>
                  <h1 className="mt-3">The Most Complete Electrical Shop</h1>
                  <p className="mt-3">Irfan Electricals provides quality electrical products and reliable services.</p>
                  <ul className="mt-3 mb-0">
                    <li className="d-inline-block text-uppercase me-2">
                      <a className="button" href="/shop">Shop Now</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </section>
      </div>

      <div className="main_2 clearfix position-absolute w-100">
        <section id="spec">
          <div className="container-xl">
            <div className="row spec">
              <div className="col-md-4">
                <div className="spec_1 bg_light p-4 rounded_5">
                  <span className="d-inline-block col_blue fs-1 float-start lh-1 me-3"><i className="fa fa-rupee"></i></span>
                  <h4>Best Price</h4>
                  <h6 className="mb-0">Over 30% discount</h6>
                </div>
              </div>
              <div className="col-md-4">
                <div className="spec_1 bg_light p-4 rounded_5">
                  <span className="d-inline-block col_blue fs-1 float-start lh-1 me-3"><i className="fa fa-rocket"></i></span>
                  <h4>Fast Shipping</h4>
                  <h6 className="mb-0">Order Over $300.00</h6>
                </div>
              </div>
              <div className="col-md-4">
                <div className="spec_1 bg_light p-4 rounded_5">
                  <span className="d-inline-block col_blue fs-1 float-start lh-1 me-3"><i className="fa fa-credit-card-alt"></i></span>
                  <h4>Quick Payment</h4>
                  <h6 className="mb-0">100% Secure</h6>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Hero;